import service from '@/store/services/workshop/warehouse-service';

const state = {
  list: {},
  warehouse: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, warehouse) => {
    state.warehouse = warehouse;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((warehouse) => { commit('SET_RESOURCE', warehouse); });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((warehouse) => { commit('SET_RESOURCE', warehouse); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((warehouse) => { commit('SET_RESOURCE', warehouse); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  warehouse: state => state.warehouse,
  page: state => state.meta.page,

};
 
const warehouse = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default warehouse;
